import { render } from "./14.vue?vue&type=template&id=1464553b"
import script from "./14.vue?vue&type=script&lang=js"
export * from "./14.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__